export default __webpack_public_path__ + "static/media/crudearrivals-overlay.e98667fb.svg";